<div class="container-box shadow-none p-3">
  <app-rental-select
    placeholder="Autofill from the existing rental"
    [multiple]="false"
    [ctrl]="rentalCtrl"
    (selectedItemsChange)="onRentalChange($event)"
    matTooltip="Selecting a property will fetch data from the rental and auto-fill the fields below. This does not link the property to a BDC listing"
    i18n-matTooltip
  ></app-rental-select>
  <form [formGroup]="form">
    <div class="row">
      <div class="col-md-6">
        <mat-form-field2>
          <input
            type="text"
            matInput
            formControlName="property_name"
            placeholder="Property Name"
            i18n-placeholder
            required
          />
          <mat-error *ngIf="form.get('property_name').touched && form.get('property_name').hasError('required')">
            <ng-container i18n>Property Name is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-md-6">
        <mat-form-field2>
          <mat-label i18n>Property Type</mat-label>
          <mat-select formControlName="property_category" required>
            <mat-option *ngFor="let propertyType of availablePropertyClassTypes" [value]="propertyType.code">
              {{ propertyType.name }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="form.get('property_category').touched && form.get('property_category').hasError('required')"
          >
            <ng-container i18n>Category is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-md-6">
        <mat-form-field2>
          <input
            type="number"
            matInput
            formControlName="room_count"
            placeholder="Room Count"
            i18n-placeholder
            required
          />
          <mat-error *ngIf="form.get('room_count').touched && form.get('room_count').hasError('required')">
            <ng-container i18n>Room Count is required</ng-container>
          </mat-error>
          <mat-error *ngIf="form.get('room_count').hasError('integer')">
            <ng-container i18n>Room Count must be an integer</ng-container>
          </mat-error>
          <mat-error *ngIf="form.get('room_count').hasError('positive')">
            <ng-container i18n>Room Count must be positive</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-md-6"></div>
      <ng-container formGroupName="check_in">
        <div class="col-md-6">
          <mat-form-field2>
            <mat-label i18n>Check-in Time From</mat-label>
            <mat-select formControlName="from" required>
              <mat-option *ngFor="let time of timeOptions" [value]="time.value">
                {{ time.label }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="checkInForm.get('from').touched && checkInForm.get('from').hasError('required')">
              <ng-container i18n>Check-in Time From is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <mat-form-field2>
            <mat-label i18n>Check-in Time Until</mat-label>
            <mat-select formControlName="until">
              <mat-option *ngFor="let time of timeOptions" [value]="time.value">
                {{ time.label }}
              </mat-option>
            </mat-select>
          </mat-form-field2>
        </div>
      </ng-container>
    </div>
  </form>
</div>
<div class="mt-3 d-flex align-items-center">
  <div class="flex-fill"></div>

  <button class="btn btn-secondary-info" [disabled]="isLoading" (click)="onSave(form)">
    <ng-container i18n>Next</ng-container>
    <i class="cs-icon cs-icon-arrow-right-long text-xxs" *ngIf="!isLoading"></i>
    <i class="far fa-spin fa-spinner" *ngIf="isLoading"></i>
  </button>
</div>
